/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiTemplateConfig} from "./UiTemplateConfig";
import {UiItemJustification} from "./UiItemJustification";


export interface UiInfiniteItemViewConfig extends UiComponentConfig {
	_type?: string;
	itemTemplate: UiTemplateConfig;
	idPropertyName: string;
	itemWidth: number;
	itemHeight: number;
	data?: any[];
	totalNumberOfRecords?: number;
	horizontalItemMargin?: number;
	verticalItemMargin?: number;
	itemJustification?: UiItemJustification
}

export interface UiInfiniteItemViewCommandHandler {
	setData(startIndex: number, data: any[], totalNumberOfRecords: number, clearTableCache: boolean): void;
	setItemTemplate(itemTemplate: UiTemplateConfig): void;
	setItemWidth(itemWidth: number): void;
	setHorizontalItemMargin(horizontalItemMargin: number): void;
	setItemJustification(itemJustification: UiItemJustification): void;
}

export interface UiInfiniteItemViewEventSource {
	onDataRequest: TeamAppsEvent<UiInfiniteItemView_DataRequestEvent>;
	onItemClicked: TeamAppsEvent<UiInfiniteItemView_ItemClickedEvent>;
}

export interface UiInfiniteItemView_DataRequestEvent extends UiEvent {
	_type: "UiInfiniteItemView.dataRequest";
	redundancyKey?: string;
	startIndex: number;
	length: number
}

export interface UiInfiniteItemView_ItemClickedEvent extends UiEvent {
	_type: "UiInfiniteItemView.itemClicked";
	redundancyKey?: string;
	recordId: any;
	isRightMouseButton: boolean;
	isDoubleClick: boolean
}

